import Wrapper from "../assets/wrappers/Navbar";
import { FaSun, FaMoon } from "react-icons/fa";
import { Link } from "react-router-dom";
import Logo from "./Logo";
import { useAppContext } from "../context/appContext";
import { useTheme } from "../context/themeContext";

const Navbar = () => {
  const { logoutUser, user } = useAppContext();
  const { theme, toggleTheme, setTheme } = useTheme();

  // Check if user is admin
  const isAdmin = user?.email === 'steven.black@gmail.com' || user?.isAdmin === true;

  // Handle logout and reset theme
  const handleLogout = () => {
    setTheme('light'); // Reset to light mode before logout
    logoutUser();
  };

  return (
    <Wrapper>
      <div className="nav-center">
        <div>
          <Logo />
        </div>

        <div className="btn-container">
          {/* Admin link - only show for admin users */}
          {isAdmin && (
            <Link
              to="/admin/formats"
              className="dropdown-btn btn-sm"
              style={{ marginRight: '10px', textDecoration: 'none' }}
              title="Manage Import Formats"
            >
              Admin
            </Link>
          )}

          {/* Dark mode toggle */}
          <button
            onClick={toggleTheme}
            className="dropdown-btn btn-sm"
            style={{ marginRight: '10px' }}
            title={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
          >
            {theme === 'dark' ? <FaSun /> : <FaMoon />}
          </button>

          {/* Logout button */}
          <button onClick={handleLogout} className="dropdown-btn btn-sm">
            logout
          </button>
        </div>
      </div>
    </Wrapper>
  );
};

export default Navbar;
